import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { stepNoteKey } from './gettingStartedSteps'

import classes from './GettingStartedStepper.module.scss'

const GettingStartedStepper = ({ steps, openStepKey, onSelect }) => {
  const { t } = useTranslation()

  return (
    <div className={classNames('d-flex', classes.stepper)}>
      {steps.map((step, index) => {
        const isOpen = step.key === openStepKey

        return (
          <button
            key={step.key}
            type='button'
            className={classNames('position-relative text-center', classes.step, {
              [classes.current]: isOpen && !step.done, [classes.done]: step.done,
            })}
            onClick={() => onSelect(step.key)}
          >
            <span className={classNames('d-flex align-items-center justify-content-center mx-auto', classes.number)}>
              {step.done ? <i className='fa fa-check' aria-hidden='true' /> : index + 1}
            </span>
            <span className={classNames('d-block', classes.title, { [classes.upcoming]: !isOpen && !step.done })}>{t(step.title)}</span>
            <span className={classNames('d-block', classes.note)}>{t(stepNoteKey(step))}</span>
          </button>
        )
      })}
    </div>
  )
}

GettingStartedStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, done: PropTypes.bool.isRequired })).isRequired,
  openStepKey: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default GettingStartedStepper
